module.exports = __webpack_public_path__ + "static/media/scanner-image.e162e674.svg";